import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';

import CorpYears from './corpYears';
import CorpList from './corpList';
import ConNav from './conNav';
import Banner from './banner';
class Content extends React.Component {
    constructor() {
        super();
        this.conNavHeader = {
            navCenter: '媒体报道',
            navRight: '凤凰新媒体',
        };

        this.state = {
            yearsContent: '285146',
        };
    }

    static propTypes = {
        content: PropTypes.object,
    };

    handleMouseYears = index => {
        if (index === 2) {
            this.setState({
                yearsContent: '285134',
            });
        } else if (index === 3) {
            this.setState({
                yearsContent: '285135',
            });
        } else if (index === 4) {
            this.setState({
                yearsContent: '285136',
            });
        } else if (index === 5) {
            this.setState({
                yearsContent: '285137',
            });
        } else if (index === 6) {
            this.setState({
                yearsContent: '285138',
            });
        } else if (index === 7) {
            this.setState({
                yearsContent: '285139',
            });
        } else if (index === 8) {
            this.setState({
                yearsContent: '285140',
            });
        } else if (index === 9) {
            this.setState({
                yearsContent: '285141',
            });
        } else if (index === 10) {
            this.setState({
                yearsContent: '285142',
            });
        } else if (index === 11) {
            this.setState({
                yearsContent: '285143',
            });
        } else if (index === 12) {
            this.setState({
                yearsContent: '285144',
            });
        } else if (index === 0) {
            this.setState({
                yearsContent: '285146',
            });
        } else if (index === 1) {
            this.setState({
                yearsContent: '285145',
            });
        }
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.pageBody}>
                <div className={styles.page}>
                    <div className={styles.pageHead}>
                        <div className={styles.pageEnd}>
                            <div className={styles.myContent}>
                                <Chip
                                    id="162635"
                                    type="static"
                                    title="首图banner"
                                    groupName="首图banner"
                                    content={content}>
                                    <Banner />
                                </Chip>
                                <ConNav conNavHeader={this.conNavHeader} />
                                <div className={styles.News} id="ynews">
                                    <Chip
                                        id="162637"
                                        type="static"
                                        title="媒体报道年份"
                                        groupName="媒体报道年份"
                                        content={content}>
                                        <CorpYears onMouseMove={index => this.handleMouseYears(index)} />
                                    </Chip>
                                    <Chip
                                        id={this.state.yearsContent}
                                        type="recommend"
                                        title="媒体报道年份"
                                        groupName="媒体报道年份"
                                        content={content}>
                                        <CorpList yearsConData={this.state.yearsContent} />
                                    </Chip>
                                </div>
                            </div>
                            <div className={styles.clear} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Content;
